import { CommonModule } from '@angular/common';
import { provideHttpClient, withInterceptorsFromDi, withXhr } from '@angular/common/http';
import { ApplicationConfig, ErrorHandler, NgModule, CUSTOM_ELEMENTS_SCHEMA, provideZoneChangeDetection } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';
import { OAuthModule, OAuthStorage } from 'angular-oauth2-oidc';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AuthComponent } from './auth/auth.component';
import { interceptors } from './interceptors/interceptors';
import { ServicesModule } from './services/services.module';
import { AppErrorHandler } from './utils/app-error-handler';
import { FormsModule } from '@angular/forms';
import { PaymentSummaryComponent } from './features/payment-transaction/payment-summary/payment-summary.component';
import { PaymentTransactionComponent } from './features/payment-transaction/payment-transaction.component';
import { AccountInformationComponent } from './features/payment-transaction/account-information/account-information.component';
import { ContractAcceptanceComponent } from './features/payment-transaction/contract-acceptance/contract-acceptance.component'; // <-- NgModel lives here
import { FooterComponent } from './features/payment-transaction/footer/footer.component';
import { HeaderComponent } from './features/payment-transaction/header/header.component';
import { MessageBoxComponent } from './features/payment-transaction/message-box/message-box.component';
import { ModalComponent } from './features/payment-transaction/modal/modal.component';
import { PaymentComponent } from './features/payment-transaction/payment/payment.component';
import { BluefinComponent } from './features/payment-transaction/bluefin/bluefin.component';

@NgModule({
  declarations: [
    AppComponent,
    AuthComponent,
    AccountInformationComponent,
    ContractAcceptanceComponent,
    PaymentSummaryComponent,
    PaymentTransactionComponent,
    FooterComponent,
    HeaderComponent,
    MessageBoxComponent,
    ModalComponent,
    PaymentComponent,
    BluefinComponent,
  ],
  imports: [BrowserModule, CommonModule, RouterModule, AppRoutingModule, OAuthModule.forRoot(), ServicesModule.forRoot(), FormsModule],
  providers: [
    // v22 made FetchBackend the default; withXhr() keeps the pre-upgrade transport.
    provideHttpClient(withInterceptorsFromDi(), withXhr()),
    // Enable zone.js change detection with event coalescing for better performance
    provideZoneChangeDetection({ eventCoalescing: true }),
    // Add App insights error handler, this will automatically log exceptions to app insights
    {
      provide: ErrorHandler,
      useClass: AppErrorHandler,
    },
    // Configure OAuth storage provider
    {
      provide: OAuthStorage,
      useFactory: (): OAuthStorage => localStorage,
    },
    // Add interceptors
    interceptors,
  ],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AppModule {}
